import { grayText2 } from '@/constant'
import { useMobileView, usePath } from '@/hooks'
import { AuthContext } from '@/layout/Auth'
import Footer from '@/layout/Footer'
import { isInWechat } from '@/utils'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { LoginBackground, LoginCard, LoginContent, LoginView, Onboarding } from './components'

export type LoginType = 'wechat' | 'password' | 'wechat_registry'

const Login = () => {
  return null
}

const Starter: React.FC = () => {
  const isMobile = useMobileView()
  return (
    <LoginView>
      {!isMobile && <LoginBackground />}
      {/* @ts-ignore */}
      <LoginContent sx={isMobile && { backgroundColor: '#fff', width: 'auto !important' }}>
        <LoginCard type='wechat_registry'>
          <Onboarding />
        </LoginCard>
      </LoginContent>
      <Footer />
    </LoginView>
  )
}

Login.Starter = Starter

export default Login
